import { combineReducers } from 'redux';
import { correlationsReducer } from 'state/quotes/correlations/correlations.reducer';
import { selectedCorrelationGraphReducer } from 'state/quotes/selectedCorrelationGraph/selectedCorrelationGraph.reducer';
import { sponsoFeesReducer } from 'state/quotes/sponsoFees/sponsoFees.reducer';
import { streamingPriceReducer } from 'state/quotes/streaming/streaming.reducer';

import { dashboardReducer } from './dashboard/dashboard.reducer';
import { detailsReducer } from './details/details.reducer';
import { infosReducer } from './infos/infos.reducer';
import { pendingDetailsReducer } from './pendingDetails/pendingDetails.reducer';
import { pendingsReducer } from './pendings/pendings.reducer';
import { pricesEnhancementsReducer } from './priceEnhancements/priceEnhancements.reducer';
import { priceImprovementRequestsReducer } from './priceEnhancements/priceImprovementRequest/priceImprovementRequest.reducer';
import { priceImprovementResponsesReducer } from './priceEnhancements/priceImprovementResponse/priceImprovementResponse.reducer';
import type { QuotesState } from './quotes.model';
import { quoteRegulationInfosReducer } from './regulations/regulation.reducer';
import { quoteResultsReducer } from './results/results.reducer';
import { tradesReducer } from './trades/trades.reducer';

export const quotesReducer = combineReducers<QuotesState>({
  details: detailsReducer,
  pendingDetails: pendingDetailsReducer,
  infos: infosReducer,
  pendings: pendingsReducer,
  results: quoteResultsReducer,
  streaming: streamingPriceReducer,
  sponsoFees: sponsoFeesReducer,
  priceEnhancements: pricesEnhancementsReducer,
  priceImprovementRequests: priceImprovementRequestsReducer,
  priceImprovementResponses: priceImprovementResponsesReducer,
  regulations: quoteRegulationInfosReducer,
  trades: tradesReducer,
  dashboard: dashboardReducer,
  correlations: correlationsReducer,
  selectedCorrelationGraph: selectedCorrelationGraphReducer,
});
